"use client";

import React, { useState, useEffect } from "react";
import Checkbox from "../../Checkbox";

type Props = {
  initialChecked: boolean;
  onCommit: (value: boolean) => void;
};

const BulkBooleanCell: React.FC<Props> = ({ initialChecked, onCommit }) => {
  const [checked, setChecked] = useState(initialChecked);
  useEffect(() => {
    setChecked(initialChecked);
  }, [initialChecked]);
  return (
    <Checkbox
      isSelected={checked}
      onClick={() => {
        const next = !checked;
        setChecked(next);
        onCommit(next);
      }}
    />
  );
};

export default BulkBooleanCell;
